export enum MeridianLoanPurposeType {
	Purchase = "0",
	Refinance = "1",
	RefinanceCashout = "2",
	Construct = "3",
	ConstructPermanent = "4",
	FHAStreamlinedRefinance = "6",
	VAIRRRL = "7",
	HomeEquity = "8",
	Other = "5",
}